module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05introduction#int"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Introduction: How to Use This Book")])]), _vm._v(" "), _c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/05introduction#int"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("6")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06setup#set"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("The Setup: Garnishes and Other Special Touches")])]), _vm._v(" "), _c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/06setup#set"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocr"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07chapter01#rec"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("RECIPES:")])])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image_bkg"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07chapter01#ch1"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font4"
  }, [_vm._v("N"), _c('sup', [_vm._v("o")]), _vm._v(". 1")]), _vm._v(" "), _c('strong', [_vm._v("Bloody Mary")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font4"
  }, [_vm._v("N"), _c('sup', [_vm._v("o")]), _vm._v(". 2")]), _vm._v(" "), _c('strong', [_vm._v("Brandy Alexander")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font4"
  }, [_vm._v("N"), _c('sup', [_vm._v("o")]), _vm._v(". 3")]), _vm._v(" "), _c('strong', [_vm._v("Daiquiri")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font4"
  }, [_vm._v("N"), _c('sup', [_vm._v("o")]), _vm._v(". 4")]), _vm._v(" "), _c('strong', [_vm._v("Gimlet")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font4"
  }, [_vm._v("N"), _c('sup', [_vm._v("o")]), _vm._v(". 5")]), _vm._v(" "), _c('strong', [_vm._v("Hot Toddy")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font4"
  }, [_vm._v("N"), _c('sup', [_vm._v("o")]), _vm._v(". 6")]), _vm._v(" "), _c('strong', [_vm._v("Irish Coffee")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/54chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font4"
  }, [_vm._v("N"), _c('sup', [_vm._v("o")]), _vm._v(". 7")]), _vm._v(" "), _c('strong', [_vm._v("Mai Tai")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/61chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font4"
  }, [_vm._v("N"), _c('sup', [_vm._v("o")]), _vm._v(". 8")]), _vm._v(" "), _c('strong', [_vm._v("Manhattan")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/70chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font4"
  }, [_vm._v("N"), _c('sup', [_vm._v("o")]), _vm._v(". 9")]), _vm._v(" "), _c('strong', [_vm._v("Margarita")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/77chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font4"
  }, [_vm._v("N"), _c('sup', [_vm._v("o")]), _vm._v(". 10")]), _vm._v(" "), _c('strong', [_vm._v("Martini")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/86chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font4"
  }, [_vm._v("N"), _c('sup', [_vm._v("o")]), _vm._v(". 11")]), _vm._v(" "), _c('strong', [_vm._v("Mimosa")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/94chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font4"
  }, [_vm._v("N"), _c('sup', [_vm._v("o")]), _vm._v(". 12")]), _vm._v(" "), _c('strong', [_vm._v("Mojito")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/102chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font4"
  }, [_vm._v("N"), _c('sup', [_vm._v("o")]), _vm._v(". 13")]), _vm._v(" "), _c('strong', [_vm._v("Moscow Mule")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/110chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font4"
  }, [_vm._v("N"), _c('sup', [_vm._v("o")]), _vm._v(". 14")]), _vm._v(" "), _c('strong', [_vm._v("Negroni")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/118chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font4"
  }, [_vm._v("N"), _c('sup', [_vm._v("o")]), _vm._v(". 15")]), _vm._v(" "), _c('strong', [_vm._v("Old Fashioned")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/125chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font4"
  }, [_vm._v("N"), _c('sup', [_vm._v("o")]), _vm._v(". 16")]), _vm._v(" "), _c('strong', [_vm._v("Paloma")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/132chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font4"
  }, [_vm._v("N"), _c('sup', [_vm._v("o")]), _vm._v(". 17")]), _vm._v(" "), _c('strong', [_vm._v("Sangria")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/139chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font4"
  }, [_vm._v("N"), _c('sup', [_vm._v("o")]), _vm._v(". 18")]), _vm._v(" "), _c('strong', [_vm._v("Shandy")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/147chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font4"
  }, [_vm._v("N"), _c('sup', [_vm._v("o")]), _vm._v(". 19")]), _vm._v(" "), _c('strong', [_vm._v("Sidecar")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/155chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font4"
  }, [_vm._v("N"), _c('sup', [_vm._v("o")]), _vm._v(". 20")]), _vm._v(" "), _c('strong', [_vm._v("Tom Collins")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/163chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_c('span', {
    staticClass: "font4"
  }, [_vm._v("N"), _c('sup', [_vm._v("o")]), _vm._v(". 21")]), _vm._v(" "), _c('strong', [_vm._v("Whiskey Sour")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/171tips#tip",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Tips: Party Planning")])]), _vm._v(" "), _c('strong', [_c('span', {
    attrs: {
      "href": "#/xhtml/171tips#tip",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("185")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/172season#sea",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Cocktails by Season and Occasion")])]), _vm._v(" "), _c('strong', [_c('span', {
    attrs: {
      "href": "#/xhtml/172season#sea",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("191")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/173primary#pri",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Cocktails by Primary Spirit or Alcoholic Ingredient")])]), _vm._v(" "), _c('strong', [_c('span', {
    attrs: {
      "href": "#/xhtml/173primary#pri",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("193")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/174resources#res",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Resources")])]), _vm._v(" "), _c('strong', [_c('span', {
    attrs: {
      "href": "#/xhtml/174resources#res",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("197")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/175acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('strong', [_c('span', {
    attrs: {
      "href": "#/xhtml/175acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("198")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a86447c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04contents.vue
// module id = 66
// module chunks = 0